module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }, [_c('span', {
    staticClass: "text_1"
  }, [_vm._v("Susie King has always loved writing stories and is highly imaginative, with a keen sense of the drama of life. Susie has been a chalet girl, daffodil picker, au pair, MP’s secretary, natural health therapist and went to a convent school where she was always getting into trouble. She loves travelling, going to the movies, trees, fish & chips, snow, the sea and anything to do with space.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_c('br', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6054a45c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0